import { format } from 'date-fns';
import { nl } from 'date-fns/locale';

export default (date, formatStr = 'PP') => {
  return format(date, formatStr, {
    locale: nl,
  });
};
